import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Persona } from "../../types"
import PersonaForm from "./PersonaForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesPersona, validationSchemaPersona } from "./PersonaCommon"
import { useMemo } from "react"

export default function PersonaModal({
  title,
  persona,
  save,
  show,
  onClose,
}: {
  title: string
  persona?: Persona
  save: (values: Persona, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
}) {
  const initialValues = useMemo(() => initialValuesPersona(persona) as Persona, [persona])
  const validationSchema = useMemo(() => validationSchemaPersona(), [])

  return (
    <Formik enableReinitialize initialValues={initialValues} validationSchema={validationSchema} onSubmit={save}>
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <PersonaForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
